$(document).ready(function () {
//   console.log('running global desktop');
  var size = $('body').outerWidth();
  var ham_container = $('.header-drawer').css('display');
  // Open menu on mouse enter
  $('body').on('mouseenter', '.header__menu-item.list-menu__item', function () {
    if (ham_container === 'none') {
 //   console.log('hovered');
    $(this).attr('aria-expanded', 'true'); // Set aria-expanded to true
    $(this).parent('details').attr('open', true); // Open the parent <details> element
   // console.log('Added open characteristic to ' + $(this).parent().attr('id'));
    }
  });

  // Close menu on mouse leave (only if leaving the entire <details> block)
  $('body').on('mouseleave', 'details', function (event) {
     if (ham_container === 'none') {
    const $details = $(this);
    // Check if the mouse has completely left the <details> block
    if (!$(event.relatedTarget).closest('details').is($details)) {
  //    console.log('Mouse left details, closing...');
      $details.removeAttr('open'); // Close the <details> element
      $details.find('.header__menu-item.list-menu__item').attr('aria-expanded', 'false'); // Update aria-expanded to false
    }
     }
  });
  $('body').on('click','.icon-hamburger',function() {
      $('#MainContent').hide();
  });
  $('body').on('click','.menu-drawer-container .icon-close',function() {
     $('#MainContent').removeAttr('style');
  });
  $('body').on('click','.jdgm-all-reviews-text',function() {
     if ($('.jdgm-all-reviews-widget').css('display') === 'none') {
    $('.jdgm-all-reviews-widget').attr('style','display:block !important');
     }
     else {
      $('.jdgm-all-reviews-widget').removeAttr('style');
     }
  });
});
// Add Rx v8: open Shopify Inbox so the shopper can tap "Add My Prescription".
$(document).on('click', 'a[href="#add-rx"]', function (e) {
  e.preventDefault();
  if (typeof gtag === 'function') {
    gtag('event', 'add_rx_click', {
      page_path: window.location.pathname,
      page_title: document.title
    });
  }
  window.megOpenRxChat();
});

// Opens the chat on its start screen, where the "Add My Prescription" button sits.
// Sending that text from code (sendStarterMessage) counts as a typed message and
// makes new visitors enter an email, so the shopper taps the button themselves.
window.megOpenRxChat = function () {
  const chat = document.querySelector('shopify-chat');
  if (!chat || typeof chat.show !== 'function') return false;
  window.megRxLead('Add My Prescription chat');
  // Wait until the tap has finished, or Inbox treats it as an outside click and closes.
  setTimeout(() => chat.show(), 50);
  return true;
};

// Meta "Lead" when a shopper starts the Rx chat. Uses the pixel Shopify's Meta app
// already puts on the page; only loads it (no PageView) if that one is missing.
// One Lead per session (whichever comes first: Rx chat or quiz contact step),
// skipped if the shopper declined marketing tracking.
window.megRxLead = function (label) {
  const PIXEL_ID = '950476870575755';
  try {
    if (sessionStorage.getItem('meg_rx_lead')) return;
    sessionStorage.setItem('meg_rx_lead', label);
  } catch (err) {}
  const privacy = window.Shopify && window.Shopify.customerPrivacy;
  if (privacy && typeof privacy.marketingAllowed === 'function' && !privacy.marketingAllowed()) return;
  if (!window.fbq) {
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
    document,'script','https://connect.facebook.net/en_US/fbevents.js');
    fbq('set', 'autoConfig', false, PIXEL_ID);
    fbq('init', PIXEL_ID);
  }
  fbq('trackSingle', PIXEL_ID, 'Lead', {
    content_name: label,
    content_category: 'Prescription',
    source_url: window.location.pathname
  });
};
